import { gql } from '@apollo/client';
import {
  GOALIE_STATS_FRAGMENT,
  PLAYER_INFO_FRAGMENT,
  PLAYER_STATS_FRAGMENT,
} from '../../fragments';

export const GET_ARCHIVE_TEAM_INFO = gql`
  ${GOALIE_STATS_FRAGMENT}
  ${PLAYER_STATS_FRAGMENT}
  ${PLAYER_INFO_FRAGMENT}
  query GetPlayersByTeam($teamId: Int!) {
    teams(where: { id: { _eq: $teamId } }) {
      champion
      color
      colorSecondary
      division
      name
      captainPlayer {
        id
        firstName
        lastName
      }
      skaterStats {
        ...PlayerStats
        playerByPlayer {
          ...PlayerInfo
        }
      }
      careerStatsGoalie {
        ...GoalieStats
        playerByPlayer {
          ...PlayerInfo
        }
      }
      seasonBySeason {
        id
        season
        year
        league
      }
    }
  }
`;
